<div class="request-rejection">
  <div class="reason">
    {{reason}}
  </div>
  <div class="selection">
    <label for="response"><strong>{{localize(langSection.RequestRejection, langText.SelectResponse)}}</strong></label>
    @if (responseOptions) {
<ups-select class="attention-dropdown" [readonly]="this.submitting"
    (change)="onChange($event)" id="response" [list]="responseOptions"></ups-select>
}
    <div class="confirmation-text text-start">
      {{confirmation}}
    </div>
  </div>
  <div>
    <button type="button" class="btn btn-green" (click)="submit()"
      [disabled]="locationProfile?.documentStatus == documentStatus().SoftDelete || this.submitting">
      {{localize(langSection.Term,langText.Submit)}}
    </button>
  </div>
</div>